<!--
 * @Author: zhubincong
 * @Date: 2020-2-24 16:06:43
 * @Desc: 预警数量分布统计
 -->
<template>
  <ViewPanel title="预警数量分布统计" scroll :active="active">
    <ul class="list">
      <li v-for="item in rankList" :key="item.alertEventName" class="item">
        <span class="name">{{ item.alertEventName }}</span>
        <span class="number">{{ item.number }}</span>
      </li>
    </ul>
  </ViewPanel>
</template>

<script>
import ViewPanel from '../Components/ViewPanel.vue'
import * as api from '@/api'
import utils from '@/utils'
import { POINT_COLOR_LIST } from '../constant'
import riskMonitoringMixins from '@/mixins/riskMonitoringMixins'

export default {
  name: 'WarnDistributionStatistics',
  components: { ViewPanel },
  mixins: [riskMonitoringMixins],
  inject: ['$riskMonitor'],
  props: {
    geoData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      rankList: []
    }
  },
  computed: {
    active() {
      return this.$riskMonitor.activePanel.toLowerCase() === this.$options.name.toLowerCase()
    }
  },
  async mounted() {
    this.mapData = null
    this.getData()
  },
  methods: {
    /**
     * 查询预警类型维度的统计
     * @author zhubincong
     * @date 2020-03-16 17:22:40
     */
    async getData() {
      const { data } = await api.emmsRiskMonitorQueryAlterEventType({
        data: { projectCode: this.$store.state.projectCode }
      })
      this.rankList = data.list
    },
    /**
     * 查询预警类型维度地图的统计
     * @author zhubincong
     * @date 2020-03-16 17:22:40
     */
    async getMapData() {
      const { data } = await api.emmsRiskMonitorQueryAlterEventTypeMap({
        data: { projectCode: this.$store.state.projectCode }
      })
      // 随机生成区域内经纬度
      this.mapData = utils.getRandomPoint4List(data.list, this.geoData)
    },

    /**
     * 渲染地图
     * @author zhubincong
     * @date 2020-03-11 18:47:37
     */
    async renderMap() {
      if (!this.mapData) {
        // 获取地图点位数据
        await this.getMapData()
      }
      const { mapChart, mapView } = this.$riskMonitor
      // 清除其他业务图表
      mapView.clear()
      if (this.mapData.length === 0) {
        mapChart.repaint()
        return
      }
      mapView.source(this.mapData)
      mapView
        .point()
        .position('longitude*latitude')
        .size(8)
        .shape('diamond')
        .opacity(0.8)
        .color('alertEventName', POINT_COLOR_LIST)
        .tooltip('alertEventName', value => ({ name: '类型', value }))

      this.configLegend(mapChart)
      mapChart.repaint()
    },
    /**
     * 刷新数据
     * @author zhubincong
     * @date 2020-03-18 17:12:42
     */
    async refreshData() {
      await this.getData()
      this.mapData = null
      if (this.active) this.renderMap()
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  padding: 0 12px;
}
.item {
  background: rgba(0, 41, 53, 0.8);
  padding: 5px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #4993a9;
  border-image: linear-gradient(90deg, #99edff1a, #4993a9) 1;
  + .item {
    margin-top: 10px;
  }
}
.name {
  font-size: 20px;
  color: #ffffff;
}
.number {
  font-size: 16px;
  color: #8feeff;
  text-align: right;
}
</style>
<style lang="scss" scoped>
@media screen and (min-width: 1900px) {
  .view-panel {
    width: 470px;
    height: 376px;
  }
}

@media screen and (min-width: 1600px) and (max-width: 1899px) {
  .view-panel {
    width: 391px;
    height: 313px;
  }
  .name {
    font-size: 14px;
  }
  .number {
    font-size: 12px;
  }
}

@media screen and (max-width: 1599px) {
  .view-panel {
    width: 313px;
    height: 250px;
  }
  .name {
    font-size: 12px;
  }
  .number {
    font-size: 10px;
  }
}
</style>
